<template>
  <div class="z-10">
    <div class="flex items-center gap-2 mb-8">
      <base-switch v-model="showJson"/>
      <label>Code editor</label>
    </div>

    <transition name="fade" mode="out-in">
      <settings-bot-theme-json v-if="showJson"
                               :key="activeTabKey"
                               class="col-span-8 my-8"
                               v-model="themeValue"
                               @update:json-validity="$emit('update:json-validity', $event)"
      />
      <settings-bot-theme-form v-else
                               v-model="themeValue"
                               :image-cache.sync="imageCacheValue"
      />
    </transition>
  </div>
</template>

<script>
import SettingsBotThemeJson from '@/components/settings/bot-theme/SettingsBotThemeJson.vue'
import BaseSwitch from '@/components/base-components/BaseSwitch.vue'
import SettingsBotThemeForm from '@/components/settings/bot-theme/SettingsBotThemeForm.vue'
import isNil from 'ramda/src/isNil'

export default {
  name: 'SettingsBotThemeEditor',

  components: {
    SettingsBotThemeForm,
    BaseSwitch,
    SettingsBotThemeJson
  },

  props: {
    activeTabKey: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    },
    imageCache: {
      type: Object,
      required: true
    }
  },

  emits: ['input'],

  data() {
    return {
      showJson: false
    }
  },

  computed: {
    imageCacheValue: {
      get() {
        return this.imageCache
      },
      set(newImageCache) {
        this.$emit('update:image-cache', newImageCache)
      }
    },
    themeValue: {
      get() {
        return this.value
      },
      set({ name, themeConfig, langConfig, launcherImageUrl }) {
        if (themeConfig) {
          this.$emit('input', { themeConfig })
        }
        if (!isNil(name)) {
          this.$emit('input', { name })
        }
        if (langConfig) {
          this.$emit('input', { langConfig })
        }
        if (!isNil(launcherImageUrl)) {
          this.$emit('input', { launcherImageUrl })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
